import React from "react";
import successIcon from "../../assets/SuccessIcon.png";
import { PrimaryButton } from "../form/primary-button";
import { AppRouteNames } from "../../routes/app-routes";
import { useNavigate } from "react-router-dom";

const UserDeletedBottomSheetContent = ({ open, setOpen, data }) => {
  const navigate = useNavigate();
  const handleClose = () => {
    setOpen(false);
    navigate(AppRouteNames.usersList);
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center text-black">
      <span className="text-pepper text-2xl  mb-3 text-center font-headings-primary">
          User deleted
        </span>
      <span className="text-pepper text-center mb-6 font-body-primary ">
          {data?.FirstName || ""} {data?.LastName || ""} was successfully deleted.
        </span>
      </div>
      <div className="flex justify-between items-center mt-2">
        <PrimaryButton
          onClick={handleClose}
          className="w-full bg-black border border-black hover:bg-pepper "
        >
          Close
        </PrimaryButton>
      </div>
    </>
  );
};

export default UserDeletedBottomSheetContent;
